import { Components } from '@mui/material/styles'

export const MuiAccordion: Components['MuiAccordion'] = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      '&:before': {
        display: 'none',
      },
    },
  },
}
